import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerYoutubeComparePostList.graphql';
import { Query, QueryinfluencerYoutubeComparePostListArgs } from '../../__generated__/globalTypes';

export const useInfluencerYoutubeComparePostListQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerYoutubeComparePostListArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerYoutubeComparePostListArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerYoutubeComparePostListLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerYoutubeComparePostListArgs>
): QueryResult<Query, QueryinfluencerYoutubeComparePostListArgs> & {
  getInfluencerYoutubeComparePostList: LazyQueryExecFunction<Query, QueryinfluencerYoutubeComparePostListArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerYoutubeComparePostList, result] = useLazyQuery<Query, QueryinfluencerYoutubeComparePostListArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getInfluencerYoutubeComparePostList, ...result };
};

export const useInfluencerYoutubeComparePostListPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerYoutubeComparePostList = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerYoutubeComparePostListArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerYoutubeComparePostListArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerYoutubeComparePostList };
};
// Suspense Query Hooks
export const useInfluencerYoutubeComparePostListSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerYoutubeComparePostListArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerYoutubeComparePostListArgs>(QUERY, {
    ...options
  });

  return result;
};
